import { render, staticRenderFns } from "./ReportPageBreaker.vue?vue&type=template&id=12016eab&scoped=true"
import script from "./ReportPageBreaker.vue?vue&type=script&lang=js"
export * from "./ReportPageBreaker.vue?vue&type=script&lang=js"
import style0 from "./ReportPageBreaker.vue?vue&type=style&index=0&id=12016eab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12016eab",
  null
  
)

export default component.exports